const getters = {
  isAuthenticated (state) {
    return state.isAuthenticated
  },
  user (state) {
    return state.user
  },
  accounts (state) {
    return state.accounts
  },
  activeAccount (state) {
    return state.activeAccount
  },
  displayLowerMinBid (state) {
    return state.displayLowerMinBid
  },
  barNotifications (state) {
    return state.barNotifications
  }
}

export default getters
